import React from 'react'
import { Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { data } from '../data';

const Presentations = () => {
    return (<>

        <Container className="outerContainer">
            <h1 className="centerText mb-4">Presentations</h1>
            <p>AHRQ engages in a variety of outreach activities to sharing information and insights about the use of the AHRQ QIs to improve health care quality. The national events listed below are a few examples of ways in which information about the AHRQ QIs is shared with hospital leaders, quality improvement specialists, researchers and other professionals throughout the country.
</p>
            {data.Resources.map((information, index) => (
                <div key={index}>
                    {information.presentations.map((presentation) => (<>
                        <Row className="mb-5 mt-5">
                            <h3>{presentation.title}</h3>
                            <p>{presentation.description}</p>

                        </Row>
                        <hr />
                    </>))}
                </div>
            ))}
            <p>For presentations prior to 2015 see the <Link to="/archive/resources?2">Archive Resources page</Link></p>
        </Container>
    </>)
}

export default Presentations;